<template>
<div class="c-recommend__list">

    <!-- デフォルト / 東京 -->
    <div v-if="getShow('default,tokyo')" class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house5.png" alt="ウィザースガーデンソレイユ南柏" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">流山市 向小金</span>
            <h3>ウィザースガーデン<br>ソレイユ南柏</h3>
            <h4>都心へ通勤しやすい人気の柏エリア</h4>
            <p>流山市と柏市のちょうど境界が南柏。近隣には学校や図書館、塾も多く、教育に対する地域全体のサポートが充実しています。東京まで通勤1時間少々と移動が便利な全20邸のZEH住宅が新たに誕生しました。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-soleil-minamikashiwa/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

    <!-- 東京 -->
    <div v-if="getShow('tokyo')" class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house6.png" alt="ウィザースガーデン船橋海神" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">船橋市 海神3丁目</span>
            <h3>ウィザースガーデン<br>船橋海神</h3>
            <h4>太陽光とエネファームのダブル発電が魅力</h4>
            <p>JR船橋駅をはじめ5駅5路線利用な、通勤・通学にとても便利なエリアです。タイル貼り＆陶器瓦の重厚な外観と、暮らしやすさへの気配りが充実したハイスペックなつくりの全12邸です。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-funabashikaijin/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

    <!-- デフォルト / 東京 -->
    <div v-if="getShow('default,tokyo')" class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house7.png" alt="ウィザースガーデン 鎌ケ谷 four seasons" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">鎌ケ谷市 鎌ケ谷九丁目</span>
            <h3>ウィザースガーデン<br>鎌ケ谷 four seasons</h3>
            <h4>人に、家計に、環境に、暮らしにやさしい街</h4>
            <p>新京成線鎌ヶ谷大仏駅から10分少々。都心まで電車で1時間以内の利便性に加え、近隣には商業施設や学校など暮らしやすさが充実しています。建物はすべて太陽光発電＋エネファームのZEH住宅。選べる外観４タイプのおしゃれな全55邸です。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-kamagaya-fs/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

    <!-- デフォルト / 神奈川 / 東京 -->
    <div class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house2.png" alt="ウィザースガーデン市川菅野" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">市川市 菅野</span>
            <h3>ウィザースガーデン<br>市川菅野</h3>
            <h4>美しい外壁タイル貼り&上質な空間デザイン</h4>
            <p>徒歩7分の最寄り駅、京成菅野駅は京成上野駅まで直通32分の価値ある立地。外壁総タイル張り全20邸の美しい街が完成しました。モデルハウス2邸を公開中です。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-ichikawasugano/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

    <!-- デフォルト / 神奈川 / 東京 -->
    <div class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house9.png" alt="ウィザースガーデン木更津瓜倉" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">千葉県木更津市 瓜倉</span>
            <h3>ウィザースガーデン<br>木更津瓜倉</h3>
            <h4>オール電化のエシカルな暮らし</h4>
            <p>木更津金田I.C.や高速バスターミナルまで2～3分、都心への通勤通学にも便利な好立地。電気代が月々3,300円になるイグニチャーソーラーを採用したオール電化仕様。家計へのやさしさと、災害時や緊急時の安心感を備えた全24邸です。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-kisarazuurikura/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

    <!-- 神奈川 -->
    <div v-if="getShow('kanagawa')" class="c-recommendBox">
        <div class="c-recommendBox__photo">
            <img src="/lp/assets/img/lp/recommend/house8.png" alt="ウィザースガーデン茂原町保セカンドステージ" width="620" height="480">
        </div>
        <div class="c-recommendBox__content">
            <span class="tag">茂原市 町保</span>
            <h3>ウィザースガーデン<br>茂原町保<br>セカンドステージ</h3>
            <h4>自然とアクティブに暮らす住まい</h4>
            <p>JR東京駅から外房線茂原駅までおよそ1時間。九十九里海岸も近い、自然と便利さのバランスが取れたエリアに、クルドサック道路の安心・安全な街、全9邸を完成させました。ゴルフ、サーフィン、アウトドア、アクティブな方にこそおすすめです。</p>
            <a class="c-btn c-btn--more" href="https://www.withearth.jp/wg-mobaramachibo2nd/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">詳しく見る</a>
        </div>
    </div>

</div>
</template>

<script>

import 'url-search-params-polyfill';

export default {
  data() {
    return {
        isState: 'default',
    }
  },
  computed: {
    getShow() {
        return (isState) => {
            if (isState.indexOf(this.isState) > -1) {
                return true;
            } else {
                return false;
            }
        }
    }
  },
  mounted() {
    const search = new URLSearchParams(window.location.search);
    if (parseInt(search.get('pnum'), 10) === 1) {
        // 神奈川
        this.isState = 'kanagawa';
    } else if (parseInt(search.get('pnum'), 10) === 2) {
        // 東京
        this.isState = 'tokyo';
    }
    //  else {
    //     // デフォルト
    //     this.isState = 'default';
    // }
  },
  methods: {
  }
}
</script>